// src/api/cart.js
import client from './client.js';

export const cartAPI = {
  get: () => client.get('/cart'),
  add: (data) => client.post('/cart', data),
  update: (id, data) => client.put(`/cart/${id}`, data),
  remove: (id) => client.delete(`/cart/${id}`),
  clear: () => client.delete('/cart'),
};